<template>
  <div
    v-if="context && context.limit"
    class="ai-context"
    :class="level"
    :title="hint"
  >
    <span class="ai-context__label">Контекст {{ percent }}%</span>
    <span class="ai-context__bar">
      <span
        class="ai-context__fill"
        :style="{ width: `${Math.min(100, percent)}%` }"
      />
      <span
        v-if="context.compactAt"
        class="ai-context__mark"
        :style="{ left: `${Math.round(context.compactAt * 100)}%` }"
      />
    </span>
    <span class="ai-context__value">{{ used }} / {{ limit }}</span>
  </div>
</template>

<script>
  import { tokens } from './format';

  const SOURCES = {
    lmstudio: 'LM Studio',
    llamacpp: 'llama.cpp',
    vllm: 'vLLM',
    ollama: 'Ollama',
    usage: 'сервер модели',
  };

  export default {
    name: 'ContextMeter',
    props: {
      context: { type: Object, default: null },
    },
    computed: {
      percent() {
        return Math.round(((this.context.used || 0) / this.context.limit) * 100);
      },
      used() {
        return tokens(this.context.used || 0);
      },
      limit() {
        return tokens(this.context.limit);
      },
      level() {
        const share = (this.context.used || 0) / this.context.limit;
        if (share >= 0.9) return 'is-danger';
        if (this.context.compactAt && share >= this.context.compactAt) return 'is-warning';
        return '';
      },
      hint() {
        const origin = SOURCES[this.context.source] || 'сервер модели';
        const lines = [
          `Занято ${(this.context.used || 0).toLocaleString('ru-RU')} из ${this.context.limit.toLocaleString(
            'ru-RU',
          )} токенов`,
          this.context.exact ? `Данные: ${origin}` : 'Оценка по размеру запроса',
        ];
        if (this.context.compactAt) {
          lines.push(`Автосжатие истории после ${Math.round(this.context.compactAt * 100)}%`);
        }
        if (this.context.model) lines.push(`Модель: ${this.context.model}`);
        return lines.join('\n');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ai-context {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    color: var(--ui-text-muted);
    font-size: 12px;
    white-space: nowrap;
  }

  .ai-context__bar {
    position: relative;
    flex: 1 1 80px;
    min-width: 60px;
    max-width: 160px;
    height: 6px;
    border-radius: 999px;
    background: var(--ui-bg-strong);
    overflow: hidden;
  }

  .ai-context__fill {
    position: absolute;
    inset: 0 auto 0 0;
    border-radius: 999px;
    background: var(--ui-primary);
    transition: width 0.3s ease;
  }

  .ai-context__mark {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 2px;
    background: var(--ui-border-strong);
  }

  .is-warning .ai-context__fill {
    background: var(--ui-warning);
  }

  .is-danger .ai-context__fill {
    background: var(--ui-danger);
  }
</style>
